import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setdeleteLesson, setloading, seterror, resetdeleteLesson
} from "../reducers/deleteLessonReducer";

const deleteLessonById = (id: any, token: any) => async (dispatch: Dispatch) => {
    dispatch(setloading(true));
    try {
        const result = await api
            .delete(
                `/lessons/delete-lesson/${id}/`,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Token ${token}`
                    },
                }
            )

        if (result) {
            dispatch(setloading(false));
            if (result.data?.status === 200) {
                dispatch(setdeleteLesson(result?.data));
            }
            else {
                dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    }
    catch (error: any) {
        dispatch(seterror(error.response.data.message));
    }
}

export { deleteLessonById, resetdeleteLesson }

